export enum FormMode {
  Building = 'building',
  Editing = 'editing',
  Filling = 'filling',
  Preview = 'preview',
}
